import React from 'react';

const CopyRight = () => {
    return (
        <>
            <div className="">
                <p>&copy; 2020 Dugilan. All right reserved</p>
            </div>
            <div>
                <i className="bi bi-twitter"></i>
                <i className="bi bi-instagram"></i>
                <i className="bi bi-facebook"></i>
                <i className="bi bi-linkedin"></i>
            </div>
        </>
    );
};

export default CopyRight;